import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updatePropertyInput } from '../PropertyActions';
import { Form, Card, CardBody } from 'reactstrap';
import { InputQuestionCurrency, InputQuestionPercent, InputQuestionText } from '../../../components/Inputs/InputQuestions';

export class MonthlyWizardPage extends Component {
    render() {
        const values = this.props.values;

        return (
            <React.Fragment>
                <h2>Monthly income &amp; costs</h2>
                <Form>
                    <InputQuestionCurrency name="income" value={values.income} title="Rent (per month)" onChange={this.props.onChangeHandler} />
                    <InputQuestionCurrency name="costsMonthlyManagement" value={values.costsMonthlyManagement} title="Management fees (per month)" onChange={this.props.onChangeHandler} />
                    <InputQuestionCurrency name="costsMonthlyBills" value={values.costsMonthlyBills} title="Bills (per month)" onChange={this.props.onChangeHandler} />
                    <InputQuestionCurrency name="costsMonthlyOther" value={values.costsMonthlyOther} title="Other costs (per month)" onChange={this.props.onChangeHandler} />
                    <InputQuestionPercent name="interestRate" value={values.interestRate} title="Interest rate" onChange={this.props.onChangeHandler} />
                </Form>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/MonthlyWizardPage.jsx